import type { BadgeTone } from '@/components/ui/badge'

export type CategoriaNovedad = 'nueva-funcionalidad' | 'mejora' | 'correccion'

export interface Novedad {
  id: string
  fecha: string
  titulo: string
  descripcion: string
  categoria: CategoriaNovedad
  plataformas: string[]
  /**
   * Pantalla del panel donde el cambio se ve. Opcional y siempre en pareja con
   * `cta`: la API descarta la entrada si viene uno sin el otro.
   */
  ruta?: string
  /** Label del botón que lleva a `ruta` ("Ir a Trabajadores"). */
  cta?: string
  /** Ya no se escribe en el data file; la API lo sigue respetando si aparece. */
  orden?: number
}

export const CATEGORIA_NOVEDAD_LABELS: Record<CategoriaNovedad, string> = {
  'nueva-funcionalidad': 'Nueva funcionalidad',
  mejora: 'Mejora',
  correccion: 'Corrección',
}

/**
 * Ícono y par de colores de cada tipo de novedad.
 *
 * El MISMO par viste el círculo del timeline y el badge de la tarjeta: el color
 * es lo que deja leer la lista en diagonal ("¿qué se arregló este mes?") sin
 * abrir cada entrada. Sale de las variantes del `Badge` del DS y no de hex
 * sueltos — un cuarto tipo se agrega acá o no existe.
 */
export interface CategoriaNovedadMeta {
  label: string
  /** Glifo de Material Symbols. */
  icono: string
  /** Variante del `Badge` del DS que pinta ese par de colores. */
  tono: BadgeTone
  /** Las mismas dos clases, para el círculo del timeline. */
  circuloClassName: string
}

export const CATEGORIA_NOVEDAD_META: Record<CategoriaNovedad, CategoriaNovedadMeta> = {
  'nueva-funcionalidad': {
    label: CATEGORIA_NOVEDAD_LABELS['nueva-funcionalidad'],
    icono: 'auto_awesome',
    tono: 'info',
    circuloClassName: 'bg-info-bg text-info',
  },
  mejora: {
    label: CATEGORIA_NOVEDAD_LABELS.mejora,
    icono: 'trending_up',
    tono: 'brand',
    circuloClassName: 'bg-primary-100 text-primary-hover',
  },
  correccion: {
    label: CATEGORIA_NOVEDAD_LABELS.correccion,
    icono: 'build',
    tono: 'warning',
    circuloClassName: 'bg-warning-bg text-warning',
  },
}
